export const dataTransform = (data) => {
	const target = ['comparisonSubjects', 'comparisonSubject', 'comparisonSubjectItem', 'comparisonIdentifiers', 'comparisonIdentifier'];

	const grouped = data.reduce((acc, obj) => {
		const seen = acc.get(obj.contentType) || []; // get the seen array, if it doesn't exist, default it []
		return acc.set(obj.contentType, seen.concat(obj)); // add the current object to its seen array, and update that Map
	}, new Map());

	const sortedData = target.flatMap((contentType) => grouped.get(contentType)); // convert every value in arr to it's corresponding array from the Map held at `id`

	const transformedData = [];
	sortedData.forEach((item) => {
		const { contentType, id, name, properties, route } = item;

		if (contentType === 'comparisonSubjects') {
			const comparisonSubjects = {
				contentType,
				children: [],
			};

			// Add to comparisonGroupFolder children if it's a subject
			transformedData.push(comparisonSubjects);
		}

		if (contentType === 'comparisonSubject') {
			const pathName = route.path.split('/').slice(-1)[0];
			const comparisonSubject = {
				contentType,
				id,
				name,
				pathName,
				children: [],
			};

			// Add the subject to the appropriate subjects group
			const comparisonSubjectsNode = transformedData.find((node) => node.contentType === 'comparisonSubjects');
			if (comparisonSubjectsNode) {
				comparisonSubjectsNode.children.push(comparisonSubject);
			}
		}

		if (contentType === 'comparisonSubjectItem') {
			const comparisonSubjectItem = {
				contentType,
				id,
				name,
				properties,
			};

			// Attach the item to the appropriate subject
			const comparisonSubjectName = route.path.split('/').slice(-2, -1)[0];
			const comparisonSubjectsNodes = transformedData.filter((node) => node.contentType === 'comparisonSubjects');

			const comparisonSubjectNode = comparisonSubjectsNodes[0].children.find((child) => child.pathName === comparisonSubjectName);

			if (comparisonSubjectNode) {
				comparisonSubjectNode.children.push(comparisonSubjectItem);
			}
		}

		if (contentType === 'comparisonIdentifiers') {
			const pathName = route.path.split('/').slice(-1)[0];
			const comparisonIdentifiers = {
				contentType,
				name,
				pathName,
				children: [],
			};

			// Add to comparisonGroupFolder children if it's an identifier group
			transformedData.push(comparisonIdentifiers);
		}

		if (contentType === 'comparisonIdentifier') {
			const comparisonIdentifier = {
				contentType,
				name,
				properties,
			};

			const comparisonIdentifiersName = route.path.split('/').slice(-2, -1)[0];
			const comparisonIdentifiersNode = transformedData.find(
				(node) => node.contentType === 'comparisonIdentifiers' && node.pathName === comparisonIdentifiersName,
			);

			if (comparisonIdentifiersNode) {
				comparisonIdentifiersNode.children.push(comparisonIdentifier);
			}
		}
	});

	return transformedData;
};
